import React, { useEffect, useRef } from 'react'
import { Calculator } from './styled-components'

export const GraphingDesmosCalculator = ({ config }) => {
  const desmosGraphingRef = useRef()

  useEffect(() => {
    const Desmos = window.Desmos
    if (desmosGraphingRef.current && Desmos) {
      const desmosGraphCalculator = Desmos.GraphingCalculator(
        desmosGraphingRef.current,
        config
      )
      desmosGraphCalculator.setExpression({ dragMode: Desmos.DragModes.XY })

      return () => {
        desmosGraphCalculator.destroy()
      }
    }
  }, [config])

  return <Calculator id="demos-basic-calculator" ref={desmosGraphingRef} />
}
